import WithRender from "../../templates/tables/summaryTable.html";

export default WithRender({
  computed: {
    name: () => {
      return "Summary";
    }
  }
});
